import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({
  title: {
    fontSize: 32,
    fontFamily: "Roboto-Bold",
    marginBottom: '1em',
  },
  card: {
    fontFamily: "Roboto-Regular",
    borderRadius: 16,
    background: 'white',
    fontSize: 16,
    height: '100%',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.10), 0 1px 3px 1px rgba(0, 0, 0, 0.10)',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
    padding: theme.spacing(3),

    '& ul': {
      display: 'flex',
      flexDirection: 'column',
      gap: `${theme.spacing(2)}px`,
      listStyle: 'none',
      padding: 0,
      margin: 0,
      '& li': {
        display: 'flex',
        '&::before': {
          content: '"\\f058"',
          fontFamily: "'Font Awesome 5 Pro'",
          fontWeight: 400,
          color: theme.palette.primary.main,
          fontSize: 18,
          lineHeight: '22px',
          marginRight: 12,
          flexShrink: 0,
        },
      },
    }
  },
  blueContainer: {
    background: 'rgba(107, 205, 219, 0.08)',
    borderTop: '5px solid #6BCDDB',
    '& $header': {
      fontSize: 24
    }
  },
  header: {
    fontFamily: "Roboto-Bold",
  },
  btnRow: {
    paddingTop: theme.spacing(1),
    marginTop: 'auto',
    textAlign: 'right',
  },
  btnRoot: {
    height: 40,
  },
  advisoryLogosWrapper: {
    padding: theme.spacing(3),
  },
  logo: {
    maxWidth: 224
  }
});

export default makeStyles(styles)